<div>
  <legend class="cdk-visually-hidden"> Reports </legend>
  <div class="search-bar-and-select-all">
    <div>
      <mat-form-field>
        <mat-label>Find</mat-label>
        <input
          autocomplete="off"
          type="text"
          matInput
          [(ngModel)]="searchText"
          [ngModelOptions]="{ standalone: true }"
          (ngModelChange)="onSearchTextChange()"
          name="search-input"
          />
          <mat-icon matSuffix class="list-search-icon">search</mat-icon>
        </mat-form-field>
      </div>
      <div>
        <mat-checkbox (change)="onSelectAllClicked($event)" [disabled]="disabled" [checked]="isAllSelected">
          Select All
        </mat-checkbox>
      </div>
    </div>
    <ul class="checkbox-container">
      @for (report of reportsToDisplay; track report) {
        <div>
          <li>
            <mat-checkbox
              [disabled]="disabled"
              [checked]="entityReportsMap[report] || hasReportFromRoles(report)"
              (change)="onCheckboxChange({ event: $event, report: report })"
              id="report-permission-{{ report }}-checkbox"
              [ngClass]="{ 'disabled-checkbox': hasReportFromRoles(report) }"
              >
            </mat-checkbox>
            <label class="mat-checkbox-label" for="report-permission-{{ report }}-checkbox">{{
              report | addSpaces
            }}</label>
          </li>
        </div>
      }
    </ul>
  </div>
